import React from 'react';
import { CheckCircle, MapPin, Building, Calendar } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ASABPhase2Page = () => {
  const facilities = [
    'Camp layout in line with civil defence requirements',
    'Fire Fighting System design',
    'Sewage, drainage, and storm water layouts',
    'F&G Detection and alarm network layout & details',
    'Building layout and details',
    'TV/Telephone & CCTV details',
    'Overall temporary site facilities design and engineering'
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://customer-assets.emergentagent.com/job_precision-vision/artifacts/kbyqktj1_ASAB.jpg)'
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70" />
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">
            EPC For ASAB Phase II Project-Camp Approvals and Engineering Services
          </h1>
          <div className="flex flex-wrap justify-center gap-6 mt-6">
            <div className="flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              <span className="text-lg">UAE</span>
            </div>
            <div className="flex items-center gap-2">
              <Building className="w-5 h-5" />
              <span className="text-lg">ADNOC</span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5" />
              <span className="text-lg">2022-2023</span>
            </div>
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Project <span className="text-red-600">Overview</span>
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" />
            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              The EPC for Asab Phase II Project (specifically FFD-2) is a major ADNOC Onshore initiative aimed at enhancing 
              oil production and processing capabilities, including upgrading RDS 1-6, installing new gas lift trains, and 
              replacing flowlines. The scope involves detailed engineering, procurement, construction, and pre-commissioning.
            </p>
            <p className="text-lg text-slate-700 leading-relaxed">
              Key aspects include temporary camp, office, and amenity construction for workforce housing, alongside specialized 
              engineering services for hazardous area electrical, civil, and pipeline works.
            </p>
          </div>

          {/* Detailed Engineering Services */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6">
              Detailed Engineering Services for Temporary Site Facilities Design
            </h3>
            <p className="text-slate-700 mb-6">
              Comprehensive engineering services for temporary site facilities ensuring workforce safety and operational efficiency:
            </p>
            <div className="grid md:grid-cols-2 gap-4">
              {facilities.map((facility, index) => (
                <Card key={index} className="border-none shadow-lg hover:shadow-xl transition-all duration-300">
                  <CardContent className="p-6">
                    <div className="flex items-start gap-3">
                      <CheckCircle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 text-base font-medium">{facility}</span>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Project Significance */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-3xl font-bold text-slate-900 mb-6">Project Significance</h3>
            <p className="text-lg text-slate-700 leading-relaxed">
              The ASAB Phase II Project demonstrates Total Vision's expertise in delivering complex EPC projects for ADNOC Onshore. 
              The comprehensive scope encompasses production enhancement through RDS upgrades, gas lift train installations, and 
              flowline replacements, while simultaneously providing essential temporary facilities for workforce accommodation. 
              This integrated approach ensures project execution excellence while maintaining safety and operational standards.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ASABPhase2Page;